module.exports = __webpack_public_path__ + "static/media/bessel.e2ba484e.png";